const OSS = require('ali-oss')

const OSSConfig = {
  uploadHost: 'https://tswl-static-resources.oss-cn-qingdao.aliyuncs.com', //OSS上传地址
  ossParams: {
    region: 'oss-cn-qingdao',
    success_action_status: '200', // 默认200
    accessKeyId: 'LTAI5tR9PmBmKzvfw6ThqfW2',
    accessKeySecret: 'd6yfVvk7wEPMw4CGzeUJ3KgmYjlQgc',
    bucket: 'tswl-static-resources',
  },
}

function random_string(len) {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function uploadOSS(file) {
  return new Promise(async (resolve, reject) => {
    const fileName = `${random_string(6)}_${file.name}`
    let client = new OSS({
      region: OSSConfig.ossParams.region,
      accessKeyId: OSSConfig.ossParams.accessKeyId,
      accessKeySecret: OSSConfig.ossParams.accessKeySecret,
      bucket: OSSConfig.ossParams.bucket,
      secure: true,
    })
    const res = await client.multipartUpload(`app/youlu_cloud/competition_portal/${fileName}`, file)
    resolve({
      id: file.lastModified,
      url: `${OSSConfig.uploadHost}/app/youlu_cloud/competition_portal/${fileName}`,
      name: file.name
    })
  })
}

export { uploadOSS }


// WEBPACK FOOTER //
// ./src/utils/oss.js